import React, { Component } from 'react';
import { Example, Properties, SourceCode, Tip } from 'examples';
import ApplicationHeader from './ApplicationHeader';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';

export default class ApplicationHeaderExample extends Component {

  state = {
    alerts: 101,
    title: 'App name',
    user: 'vcc@vimond.com',
    logo: 'vimond'
  };

  onChange = e => this.setState(e.target.value);

  onClickUser = e => {
    e.preventDefault();
    window.showAppInfo('user');
  };

  render() {
    const menuItems = [
      <Button key="0" iconName="asset">Assets</Button>,
      <Button key="2" iconName="category">Catalog</Button>,
      <Button key="3" iconName="curation" className="active">Curator</Button>,
      <Button key="4" iconName="rights-manager">Rights Manager</Button>,
      <Button key="5" iconName="images">Image Bank</Button>,
      <Button key="6" iconName="live">Live</Button>,
      <Button key="7" iconName="insights">Insights</Button>,
      <Button key="8" iconName="monetization">Monetization</Button>,
      <Button key="9" iconName="accounts">Accounts</Button>,
      <Button key="10" iconName="settings">Settings</Button>,
    ];
    const secondaryItems = [
      <Button key="1">Feed Ingest</Button>,
      <Button key="2">Monitoring</Button>,
      <Button key="3">Tag Gallery</Button>,
      <Button key="4">IO</Button>,
      <Button key="5">Audit Log</Button>,
    ];
    const pinnedItems = [
      <a>Pinned item</a>,
    ];
    const user = <a href="" onClick={this.onClickUser}>{this.state.user}</a>;

    return (
      <Example {...this.props}>
        <Properties defaultProps={ApplicationHeader.defaultProps} propTypes={ApplicationHeader.propTypes}
          propValues={this.state} onChange={this.onChange}>
          <Tip>Click on the <Icon name="menu"/> icon in the header to open the header menu.</Tip>
        </Properties>
        <ApplicationHeader {...this.state} menuItems={menuItems} secondaryItems={secondaryItems} pinnedItems={pinnedItems} user={user}/>
        <SourceCode querySelector=".application-header-example .core-application-header"/>
      </Example>
    );

  }

}
